import React from "react";
import dayjs from "dayjs";

const VoiceMailViewModal = ({ open, onClose, voicemail, formatDate, formatTime }) => {
  if (!open || !voicemail) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/40"
        onClick={onClose}
      ></div>

      {/* Modal Box */}
      <div className="relative text-start bg-white rounded-lg shadow-xl w-full max-w-lg mx-4 p-6 overflow-y-auto max-h-[85vh]">
        <h2 className="text-lg font-semibold mb-4 text-[#232323]">
          Voicemail Details
        </h2>

        {/* === Caller Information UI (Copied from main UI) === */}
        <div className="bg-white rounded-xl border border-[#E5E7EB] p-6">
          <h3 className="text-[15px] text-left font-inter font-medium text-[#232323] mb-4">
            Caller Information
          </h3>

          <div className="flex flex-col gap-y-6 text-sm">
            <div className="grid grid-cols-2 gap-8 w-full">
              <div>
                <span className="text-[#7E7E7E] text-sm font-medium font-inter text-left block mb-1">
                  Name:
                </span>
                <div className="font-medium text-left text-[#111827]">
                  {voicemail?.from?.name || "-"}
                </div>
              </div>

              <div>
                <span className="text-[#7E7E7E] text-sm font-medium font-inter text-left block mb-1">
                  Phone:
                </span>
                <div className="font-medium text-left text-[#111827]">
                  {voicemail?.from?.phoneNumber || "-"}
                </div>
              </div>
            </div>

            {/* Row 2 */}
            <div className="grid grid-cols-2 gap-8 w-full">
              <div>
                <span className="text-[#7E7E7E] text-sm font-medium font-inter text-left block mb-1">
                  Date & Time:
                </span>
                <div className="font-medium text-left text-[#111827]">
                  {formatDate(voicemail?.creationTime) || "-"}
                </div>
              </div>

              <div>
                <span className="text-[#7E7E7E] text-sm font-medium font-inter text-left block mb-1">
                  Duration:
                </span>
                <div className="font-medium text-left text-[#111827]">
                  {formatTime(voicemail?.duration || 0) || "-"}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Close Button */}
        <div className="flex justify-end mt-5">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-[#50869A] text-white text-sm rounded-md hover:opacity-90"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default VoiceMailViewModal;
